// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"Fieldset_fieldset__t_isp","fieldset__legend":"Fieldset_fieldset__legend__EfFiw"};